import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-sm confirmation-form" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col" }

import * as UserAttributeCode from '../../../common/code/UserAttributeCode';

interface Props {
  memberInfo: {
    // ユーザー情報
    user_name_sei: string;
    user_name_mei: string;
    mail_address: string;
    mail_address_conf: string;
    user_attribute: UserAttributeCode.default;
    // 所属先情報
    work_school_name: string;
    affiliation_department_name: string;
    postal_cd: string;
    todohuken_name: string;
    street_address: string;
    phone_number: string;
    [key: string]: string;
  };
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationForm',
  props: {
    memberInfo: {}
  },
  setup(__props: any) {

const props = __props;

// 表示時にトップにスクロール
window.scrollTo({
  top: 0,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-4 text-right q-mr-md" }, [
        _createElementVNode("label", null, "お名前（姓）")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(props.memberInfo.user_name_sei), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-4 text-right q-mr-md" }, [
        _createElementVNode("label", null, "お名前（名）")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(props.memberInfo.user_name_mei), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-4 text-right q-mr-md" }, [
        _createElementVNode("label", null, "会員ID（メールアドレス）")
      ], -1)),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", null, _toDisplayString(props.memberInfo.mail_address), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-4 text-right q-mr-md" }, [
        _createElementVNode("label", null, "ご担当")
      ], -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", null, _toDisplayString(UserAttributeCode.getName(props.memberInfo.user_attribute)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-4 text-right q-mr-md" }, [
        _createElementVNode("label", null, "勤務先／学校名")
      ], -1)),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", null, _toDisplayString(props.memberInfo.work_school_name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-4 text-right q-mr-md" }, [
        _createElementVNode("label", null, "所属／学部名")
      ], -1)),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", null, _toDisplayString(props.memberInfo.affiliation_department_name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-4 text-right q-mr-md" }, [
        _createElementVNode("label", null, "郵便番号")
      ], -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("span", null, _toDisplayString(props.memberInfo.postal_cd), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-4 text-right q-mr-md" }, [
        _createElementVNode("label", null, "都道府県")
      ], -1)),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("span", null, _toDisplayString(props.memberInfo.todohuken_name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-4 text-right q-mr-md" }, [
        _createElementVNode("label", null, "市区町村以下")
      ], -1)),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("span", null, _toDisplayString(props.memberInfo.street_address), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-4 text-right q-mr-md" }, [
        _createElementVNode("label", null, "電話番号")
      ], -1)),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("span", null, _toDisplayString(props.memberInfo.phone_number), 1)
      ])
    ])
  ]))
}
}

})